export default {"src":"/_next/static/media/prev.bc00226e.svg","height":200,"width":200};